import { message } from 'antd'; 
// On success
export const handleSuccess = (msg:any) => {
    message.success(msg);
  };
  
  // On error
  export const handleError = (msg:any) => {
    message.error(msg);
  };